import axios from '../../../../../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/ai/AssistantInstation/list",{
        params: {
          ...params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/ai/AssistantInstation/created",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/ai/AssistantInstation/info",{ id:params } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/ai/AssistantInstation/updated",{...params} )
}

function DELE(params) {
    return  axios.get("/ai/AssistantInstation/deleted",{
        params: {
            ids:params
        }
    } )
}
function GET_MENU(params) {
    return  axios.get("/ai/Assistant/menu",{
        params: {
...params
        }
    } )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,GET_MENU
};